<template>
    <div class="row">
        <div class="col-md-6">
            <div class="card">
                <div class="card-header">Apply Leave</div>
                <div class="card-body">
                    <Form :validation-schema="schema" v-slot="{ handleSubmit, errors }" as="div">
                        <div class="row g-3">
                            <!-- <div class="col-md-12">
                                <label for="leave_type" class="form-label">Leave Type <span class="text-danger">*</span></label>
                                <select
                                    id="leave_type"
                                    class="form-select"
                                    name="leave_type"
                                    :class="{ 'is-invalid': errors.leave_type }"
                                    v-model="leaveData.leave_type"
                                >
                                    <option value="one_day">One Day</option>
                                    <option value="multiple_days">Multiple Days</option>
                                </select>
                                <div v-if="errors.leave_type" class="is-invalid invalid-feedback">{{ errors.leave_type }}</div>
                            </div> -->
                            <div class="col-md-6">
                                <label for="date" class="form-label">Start Date <span class="text-danger">*</span></label>
                                <!-- <VueDatePicker
                                    name="date"
                                    v-model="leaveDates"
                                    :format="'dd-MM-yyyy'"
                                    :enable-time-picker="false"
                                    :display-marker="false"
                                    :clearable="false"
                                    :timezone="'UTC'"
                                    :range="(leaveData.leave_type === 'multiple_days')"
                                    :min-date="new Date()"
                                ></VueDatePicker> -->
                                <VueDatePicker
                                    name="start_date"
                                    v-model="leaveData.start_date"
                                    :format="'dd-MM-yyyy'"
                                    :enable-time-picker="false"
                                    :display-marker="false"
                                    :clearable="false"
                                    :timezone="'UTC'"
                                    :min-date="new Date()"
                                    auto-apply="true"
                                ></VueDatePicker>
                            </div>
                            <div class="col-md-6">
                                <label for="date" class="form-label">End Date</label>
                                <VueDatePicker
                                    name="end_date"
                                    v-model="leaveData.end_date"
                                    :format="'dd-MM-yyyy'"
                                    :enable-time-picker="false"
                                    :display-marker="false"
                                    :clearable="false"
                                    :timezone="'UTC'"
                                    :min-date="leaveData.start_date"
                                    :auto-apply="true"
                                ></VueDatePicker>
                            </div>

                            <div class="col-md-12">
                                <label for="message" class="form-label">Comment <span class="text-danger">*</span></label>
                                <Field
                                    as="textarea"
                                    id="message"
                                    class="form-control"
                                    placeholder="Enter Comment"
                                    rows="4"
                                    name="comment"
                                    :class="{ 'is-invalid': errors.comment }"
                                    v-model="leaveData.comment"
                                ></Field>
                                <div v-if="errors.comment" class="is-invalid invalid-feedback">{{ errors.comment }}</div>
                            </div>

                            <div class="col-md-12">
                                <button
                                    type="button"
                                    class="btn btn-theme float-end"
                                    :class="{ 'disabled': processing }"
                                    :disabled="processing"
                                    v-text="processing ? 'Processing...' : 'Apply Leave'"
                                    @click="handleSubmit($event, applyForLeave)"
                                ></button>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card">
                <div class="card-header">Upcoming Leaves</div>
                <div class="card-body">
                    <table class="table table-borderless hm-fs-12 align-middle table-striped mb-0">
                        <thead>
                            <tr class="sticky-top">
                                <th class="text-center bg-theme">Date</th>
                                <th class="text-center bg-theme">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-if="Object.keys(leaves).length > 0"
                                v-for="(leave, index) in leaves"
                            >
                                <td class="text-center">
                                    {{ $dateTimeFormat(leave.start_date, 'DD-MMM-YYYY') }}
                                    {{ leave.end_date ? ' to ' + $dateTimeFormat(leave.end_date, 'DD-MMM-YYYY') : '' }}
                                </td>
                                <td class="text-center text-capitalize">{{ leave.status }}</td>
                            </tr>
                            <tr v-else-if="processing">
                                <td colspan="2" class="text-center">Processing...</td>
                            </tr>
                            <tr v-else>
                                <td colspan="2" class="text-center">No upcoming leaves found.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { set } from 'lodash';
import moment from 'moment';

export default {
    name: 'ApplyLeave',
    components: {},
    data() {
        return {
            processing: false,
            leaveData: {
                leave_type: 'one_day',
                date: moment().clone().day(6).format('YYYY-MM-DD'),
                leave_range: [moment().clone().day(6).format('YYYY-MM-DD'), moment().clone().day(6).add(1, 'days').format('YYYY-MM-DD')],
                start_date: moment().format('YYYY-MM-DD'),
                end_date: null,
                comment: ''
            },
            leaves: [],
        }
    },
    mounted() {
        this.getUpcomingLeaves();
    },
    computed: {
        schema() {
            return {
                comment: 'required',
            }
        },
        leaveDates: {
            get() {
                return this.leaveData.leave_type === 'one_day' ? this.leaveData.date : this.leaveData.leave_range;
            },
            set(value) {
                if( this.leaveData.leave_type === 'one_day') {
                    this.leaveData.date = value;
                } else {
                    this.leaveData.leave_range = value;
                }
            }
        }
    },
    watch: {
        'leaveData.start_date': {
            handler(val) {
                // Check if end date is less than start date
                if (this.leaveData.end_date && this.leaveData.end_date < val) {
                    this.leaveData.end_date = null;
                }
            },
            immediate: true
        }
    },
    methods: {
        getUpcomingLeaves() {
            let self = this;
            axios.get('/handyman/upcoming-leaves')
                .then(response => {
                    if (response.data.status === 'success') {
                        self.leaves = response.data.leaves;
                    }
                });
        },
        applyForLeave() {
            let self = this;
            this.processing = true;

            axios.post('/handyman/save-leave-request', this.leaveData)
                .then(response => {
                    if (response.data.status === 'success') {
                        self.$notification('success', response.data.message);
                        self.processing = false;
                        self.leaveData = {
                            leave_type: 'one_day',
                            date: moment().clone().day(6).format('YYYY-MM-DD'),
                            leave_range: [moment().clone().day(6).format('YYYY-MM-DD'), moment().clone().day(6).add(1, 'days').format('YYYY-MM-DD')],
                            comment: '',
                            start_date: moment().format('YYYY-MM-DD'),
                            end_date: null
                        };
                        self.getUpcomingLeaves();
                    }
                })
                .catch(error => {
                    self.processing = false;
                    self.$notification('error', error.response.data.message);
                })
                .finally(() => {
                    self.processing = false;
                });
        }
    }
}
</script>
